"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyPattern = exports.datePattern = exports.phoneNumber = exports.emailPattern = exports.cyrrillicsOnly = exports.decimalNumbers = exports.simpleNumbersOnly = void 0;
exports.simpleNumbersOnly = /^\d*$/;
exports.decimalNumbers = /^\d*(\.)?\d{1,20}$/;
exports.cyrrillicsOnly = /^[ а-яА-ЯёЁ]*$/;
// Standart email validation that matches almost all email formats
// eslint-disable-next-line
exports.emailPattern = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
exports.phoneNumber = /^\+?\d(\(\d{0,3}\)|\d{0,3})(\d{3})(-(\d{2})-(\d{2})|(\d{4}))$/;
exports.datePattern = /^\d{2}\.\d{2}\.\d{4}$/;
exports.isEmptyPattern = /\w+/g;
